import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const dynamicPricingConfig = {
  createDynamicPricing: {
    key: "createDynamicPricing",
    url: "/api/v1/pricing-rules",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getDynamicPricing"],
    },
  },

  calculatePrice: {
    key: "calculatePrice",
    url: "/api/v1/pricing/calculate",
    method: "POST",
    options: {
      retry: 2,
    },
  },
  getDynamicPricing: {
    key: "getDynamicPricing",
    url: "/api/v1/pricing-rules",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  getDeletedPricingRules: {
    key: "getDeletedPricingRules",
    url: "/api/v1/pricing-rules/deleted",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
  updateDynamicPricing: {
    key: "updateDynamicPricing",
    url: (data) => `/api/v1/pricing-rules/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getDynamicPricing"],
    },
  },
  softDeleteDynamicPricing: {
    key: "softDeleteDynamicPricing",
    url: (data) => `/api/v1/pricing-rules/${data.id}`,
    method: "DELETE",
    options: {
      retry: 2,
      invalidateKeys: ["getDynamicPricing"],
    },
  },
  restoreDynamicPricing: {
    key: "restoreDynamicPricing",
    url: (data) => `/api/v1/pricing-rules/${data.id}/restore`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getDynamicPricing"],
    },
  },
};
